/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { InitiateRequestBuilderRequestsMetadata, type InitiateRequestBuilder } from './initiate/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /files/upload
 */
export interface UploadRequestBuilder extends BaseRequestBuilder<UploadRequestBuilder> {
    /**
     * The initiate property
     */
    get initiate(): InitiateRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const UploadRequestBuilderUriTemplate = "{+baseurl}/files/upload";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const UploadRequestBuilderNavigationMetadata: Record<Exclude<keyof UploadRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    initiate: {
        requestsMetadata: InitiateRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
